import { Form, Tabs } from "antd";
import { useEffect, useMemo } from "react";
import { useGetAbsencesQuery } from "../../../../api/plamo-api";

import styled from "styled-components";
import EmployeeAbsenceList from "./employee-absence-list";
import EmployeeAbsenceDetails from "./employee-absence-details";

const TabsStyled = styled(Tabs)`
  flex: 1;
  overflow: hidden;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
  }
`

function EmployeeAbsences({ employeeId, subpage }) {
  const [form] = Form.useForm();
  const { data } = useGetAbsencesQuery({ f: JSON.stringify({ "employee.id": { c: "EQ", v: employeeId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  
  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const tabItems = useMemo(() => [
    {
      key: 'vacation',
      label: 'Urlaub',
      children: <EmployeeAbsenceList employeeId={employeeId} reason="Urlaub" comparator="EQ" />
    },
    {
      key: 'other',
      label: 'Andere',
      children: <EmployeeAbsenceList employeeId={employeeId} reason="Urlaub" comparator="NEQ" />
    }
  ], [employeeId])

  if(subpage) {
    return <EmployeeAbsenceDetails employeeId={employeeId} id={subpage} />
  } else {
    return <TabsStyled items={tabItems} />
  }
}

export default EmployeeAbsences